import { ThunkAction } from 'redux-thunk';
import * as Bixby from './../../core';
import { AppState } from '../index';

import { PROFILE_LOADING, PROFILE_SUCCESS, PROFILE_FAILURE } from './types';
import { ProfileService, AnalyticsService } from '$/services';

// thunk actions
/**
 * Thunk action to get current profile
 */
export const getProfile =
  (): ThunkAction<Promise<Bixby.Models.Profile>, AppState, null, Bixby.Models.BixbyAction> =>
  async (dispatch, getState) => {
    dispatch(loadProfileAction());
    try {
      const profile = ProfileService.getProfileFromState(getState) as Bixby.Models.Profile;
      if (!profile) {
        throw new Error(`Expected profile from decoded token.`);
      }
      dispatch(profileSuccessAction(profile));
      AnalyticsService.event(Bixby.Constants.APPINSIGHTS_PROFILE_LOADED, profile);
      return profile;
    } catch (error: any) {
      dispatch(profileFailureAction(error));
      throw error;
    }
  };

/**
 * Load profile action creator
 */
export const loadProfileAction = () => {
  return {
    type: PROFILE_LOADING,
  };
};

/**
 * Successfully loaded profile action creator
 * @param profiles user profile
 */
export const profileSuccessAction = (payload: Bixby.Models.Profile) => {
  return {
    type: PROFILE_SUCCESS,
    payload,
  };
};

/**
 * Unsuccessfully loaded profile action creator
 * @param error error when trying to load user profile
 */
export const profileFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: PROFILE_FAILURE,
    payload: error,
    error: true,
  };
};
